export function Hide({hide, children}) {
  return (
    !hide ? children : <></>
  );
}